import React from "react";
import { Button, Modal, Form, Input, Space, Switch } from "antd";
import { DepartmentModalProps } from "../../types/job";

const DepartmentModal: React.FC<DepartmentModalProps> = ({
  visible,
  form,
  onFinish,
  onCancel,
  editingRecord,
}) => {
  return (
    <Modal
      title={editingRecord ? "Chỉnh sửa phòng ban" : "Thêm phòng ban"}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="name"
          label="Tên"
          rules={[{ required: true, message: "Tên không được để trống" }]}
        >
          <Input placeholder="Tên phòng ban" />
        </Form.Item>

        <Form.Item
          name="isHidden"
          label="Trạng thái"
          valuePropName="checked"
          getValueProps={(value) => ({ checked: !value })}
          getValueFromEvent={(checked) => !checked}
          initialValue={editingRecord?.isHidden || false}
        >
          <Switch defaultChecked />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit">
              Lưu
            </Button>
            <Button onClick={onCancel}>Huỷ</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DepartmentModal;
